import { Callout } from '@neshane/blueberry';
import { useEffect, useState } from 'react';

import { Footer } from '../Footer';
import { UnsavedModal } from '../UnsavedModal';

import styles from './CenteredLayout.module.css';

export const CenteredLayout = ({
    children,
    actions,
    title,
    allowOnBack,
    goBack,
    isDirty,
    showFooter = true,
}) => {
    const [isOnline, setIsOnline] = useState(
        typeof navigator !== 'undefined' ? navigator.onLine : true
    );
    const [isUnsavedModalOpen, setIsUnsavedModalOpen] = useState(false);

    useEffect(() => {
        const setOnline = () => setIsOnline(true);
        const setOffline = () => setIsOnline(false);
        window.addEventListener('online', setOnline);
        window.addEventListener('offline', setOffline);
        return () => {
            window.removeEventListener('online', setOnline);
            window.removeEventListener('offline', setOffline);
        };
    }, []);

    const handleBack = () => {
        setIsUnsavedModalOpen(false);
        if (goBack) goBack();
    };

    const onBackButtonClicked = () => {
        if (isDirty) {
            setIsUnsavedModalOpen(true);
            return;
        }
        handleBack();
    };

    return (
        <>
            <section className={styles.container} aria-labelledby="kyc-step">
                <h1 id="kyc-step" className={styles.title}>
                    {title}
                </h1>
                <div className="col-start-2">{children}</div>
                {!isOnline && (
                    <Callout
                        variant="alert"
                        className="col-start-2 mt-8"
                        title="اتصال به اینترنت برقرار نیست"
                    />
                )}

                {showFooter && (
                    <Footer
                        actions={actions}
                        allowOnBack={allowOnBack}
                        handleBack={onBackButtonClicked}
                    />
                )}
            </section>
            <UnsavedModal
                isOpen={isUnsavedModalOpen}
                onClose={() => setIsUnsavedModalOpen(false)}
                onContinue={handleBack}
            />
        </>
    );
};